import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const BacklogService = {
  getBacklog(clientId) {
    return fetchWithToken(`${config().backlogService}/?clientid=${clientId}`, { method: 'GET' })
      .then((response) => response.json())
  },
}
